module.exports = __webpack_public_path__ + "img/title-2.b27deb06.png";